import { render, staticRenderFns } from "./NeedReport.vue?vue&type=template&id=1bd8ba71&scoped=true&"
import script from "./NeedReport.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedReport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8ba71",
  null
  
)

export default component.exports